import { html } from "uhtml";
import { locales } from "../../models/locales.js";
import { desktopHints } from "./desktopHints.js";

export function bottomNavigation(
  locale,
  pageNumber,
  showNavigation,
  pages = [pageNumber],
  count = 0,
) {
  // The hrefs are a fallback; events.js turns these links into
  // goToPrevious()/goToNext(), which know about spreads.
  const lastVisible = pages[pages.length - 1];
  const prevPage = `#page=${Math.max(pageNumber - 1, 1)}`;
  const nextPage = `#page=${lastVisible + 1}`;
  const prevStyles = pageNumber <= 1 ? "display: none;" : "display: block";
  const nextStyles =
    count > 0 && lastVisible >= count ? "display: none;" : "display: block";
  const className = showNavigation
    ? "links bottom active"
    : "links bottom inactive";
  return html`
		${desktopHints(locale)}
<nav class="publication" aria-label="${locales.pages[locale]}" lang="${locale}">
<div class="controls">
	<ul class="${className}">
    <li>
      <a rel="prev" style="${prevStyles}" href="${prevPage}" aria-labelledby="previous-label"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 19 19" preserveAspectRatio="xMidYMid meet" role="img" class="icon" aria-labelledby="previous-icon">
        <title id="previous-icon">${locales.previousPage[locale]}</title>
        <path d="M9.5.96C4.736.96.86 4.836.86 9.6s3.876 8.64 8.64 8.64c4.764 0 8.641-3.877 8.641-8.64 0-4.764-3.877-8.64-8.641-8.64zm0 16.669c-4.427 0-8.029-3.602-8.029-8.029S5.073 1.571 9.5 1.571s8.029 3.602 8.029 8.029-3.602 8.029-8.029 8.029z"></path><path d="M10.92 5.865a.306.306 0 0 0-.432 0L7.1 9.253a.492.492 0 0 0 0 .694l3.388 3.388a.305.305 0 1 0 .432-.433L7.617 9.6l3.303-3.303a.306.306 0 0 0 0-.432z"></path>
      </svg>
      <span class="chapter-control" id="previous-label">${
        locales.previousPage[locale]
      }</span>
      </a>
    </li>
    <li class="info bottom">
    	<cassis-chapter-position></cassis-chapter-position>
    </li>
    <li>
      <a rel="next"  style="${nextStyles}" href="${nextPage}" aria-labelledby="next-label">
        <span class="chapter-control" id ="next-label">${
          locales.nextPage[locale]
        }</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 19 19" preserveAspectRatio="xMidYMid meet" role="img" class="icon" aria-labelledby="next-icon">
          <title id="next-icon">${locales.nextPage[locale]}</title>
          <path d="M9.5 18.24c4.764 0 8.641-3.877 8.641-8.64 0-4.764-3.877-8.64-8.641-8.64S.86 4.836.86 9.6s3.876 8.64 8.64 8.64zm0-16.669c4.427 0 8.029 3.602 8.029 8.029s-3.603 8.029-8.029 8.029S1.471 14.027 1.471 9.6 5.073 1.571 9.5 1.571z"></path><path d="M8.08 13.335a.306.306 0 0 0 .432 0L11.9 9.947a.494.494 0 0 0 0-.694L8.512 5.865a.306.306 0 0 0-.432.432L11.383 9.6 8.08 12.902a.305.305 0 0 0 0 .433z"></path>
        </svg>
      </a>
    </li>
  </ul>
</div>
<!-- /controls -->
</nav>`;
}
